import configureYousersJS from './configure-yousersjs';
import fetchUserPreferences from './fetch-user-preferences';

export default {
  configureYousersJS,
  fetchUserPreferences,
};
